import { USE_MOCK_API } from '../config';
import type { AdminMailDeliveryProgress, AdminMailDraft, AdminMailPreview } from '../types/domain';
import { http } from './http';
import { assertMock, mockDelay } from './mock';

export const adminMailApi = {
  async preview(draft: AdminMailDraft): Promise<AdminMailPreview> {
    if (!USE_MOCK_API) return http.post<AdminMailPreview>('/admin/mail/preview', draft);
    assertMock('adminMailApi.preview');
    return mockDelay({
      html: `<html><body><h1>${draft.heading}</h1><p>${draft.message}</p></body></html>`,
      recipientCount: 0,
    });
  },

  async send(draft: AdminMailDraft, dispatchId: string): Promise<AdminMailDeliveryProgress> {
    if (!USE_MOCK_API) {
      return http.post<AdminMailDeliveryProgress>('/admin/mail/send', { ...draft, dispatchId });
    }
    assertMock('adminMailApi.send');
    return mockDelay({
      id: dispatchId,
      status: 'completed',
      recipientCount: 0,
      processedCount: 0,
      sentCount: 0,
      failedCount: 0,
      failedEmails: [],
    });
  },

  async getProgress(dispatchId: string): Promise<AdminMailDeliveryProgress> {
    if (!USE_MOCK_API) {
      return http.get<AdminMailDeliveryProgress>(`/admin/mail/send/${dispatchId}`);
    }
    assertMock('adminMailApi.getProgress');
    return mockDelay({
      id: dispatchId,
      status: 'completed',
      recipientCount: 0,
      processedCount: 0,
      sentCount: 0,
      failedCount: 0,
      failedEmails: [],
    });
  },
};
